import http from "axios";
import storage from "../components/utils/storage";

const API_URL = process.env.VUE_APP_API_URL;
let config = {};

function loadConfig() {
  const token = storage.loadToken();
  config = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
}

export default {
  fetchFiltersData: (filters) => {
    loadConfig();
    return http.post(`${API_URL}/order/filtered`, filters, config);
  },
  fetchByFilters: (filters) => {
    loadConfig();
    return http.post(`${API_URL}/order`, filters, config);
  },
  fetchById: (id) => {
    loadConfig();
    return http.get(`${API_URL}/order/${id}`, config);
  },
  downloadScreenshot: (orderId, currentTime) => {
    loadConfig();
    const configWithBlob = {
      ...config,
      responseType: "blob",
    };
    return http.get(
      `${API_URL}/videos/${orderId}/${currentTime}`,
      configWithBlob
    );
  },
  downloadVideoSegment: (orderId, startTime, endTime) => {
    loadConfig();
    const configWithBlob = {
      ...config,
      responseType: "blob",
    };
    return http.get(
      `${API_URL}/videos/${orderId}/${startTime}/${endTime}`,
      configWithBlob
    );
  },
};
